import { apiRequest } from '../apiRequest';
import { 
  FETCH_GEOJSON_DATA_ENDPOINT
} from '../urls';

export const fetchGeojsonData = () => { 
  return apiRequest('GET', FETCH_GEOJSON_DATA_ENDPOINT);
}

